import { render, staticRenderFns } from "./SectorTags.vue?vue&type=template&id=2139593c&scoped=true&lang=html&"
import script from "./SectorTags.vue?vue&type=script&lang=js&"
export * from "./SectorTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139593c",
  null
  
)

export default component.exports